import Image from 'next/image'

export default function VisionStatementSection() {
  return (
    <section
      className='mx-auto grid grid-cols-12 gap-5 bg-cover bg-center bg-no-repeat px-4 py-12 md:px-16 md:pb-32'
      style={{
        backgroundImage: `url('https://mcdn.coolmate.me/image/March2025/mceclip1_141.jpg')`,
      }}
    >
      <div className='col-span-12 grid grid-cols-12 text-center md:col-span-8 md:col-start-3'>
        <div className='col-span-8 col-start-3 md:col-span-4 md:col-start-5'>
          <Image
            src='https://mcdn.coolmate.me/image/March2025/mceclip0_85.png'
            alt='Vision 2030'
            width={1000}
            height={1000}
            className='w-full'
          />
        </div>
        <div className='md:text-heading-5 2xl:text-heading-4 col-span-12 mt-5 font-criteria text-2xl !font-medium italic leading-[1.1] text-white md:mt-10'>
          &ldquo;Sẵn sàng thay đổi để thực hiện điều mới&rdquo;
        </div>
        <div className='col-span-12 mt-5 text-sm text-white md:mt-10 md:text-lg'>
          Nhân dịp sinh nhật 6 tuổi, Coolmate công bố tầm nhìn đến 2030 và chiến
          lược phát triển từ 2025 - 2030. <br />
          Tuyên bố này như một sự cam kết mạnh mẽ của đội ngũ Coolmate nhằm xây
          dựng một Coolmate thật sự thú vị và bền vững
        </div>
        <div className='col-span-12 mt-2 text-sm text-white md:text-lg'>
          Coolmate đặt mục tiêu trở thành thương hiệu thời trang biểu tượng của
          Việt Nam, dẫn đầu thị trường trong nước và mở rộng toàn cầu. Thành
          công này sẽ dựa trên ba trụ cột chính: chuỗi cung ứng xuất sắc, ứng
          dụng công nghệ và dữ liệu, và khả năng kết nối mạnh mẽ với khách hàng.
        </div>
      </div>
    </section>
  )
}
